import { HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

export enum EndPoints {
    login = 'Account/Login',
    tokenLogin = 'Account/TokenLogin',
    logout = 'Account/Logout',
    forgotUsername = 'Account/ForgotUserId',
    forgotPassword = 'Account/ForgotPassword',
    userFeature = 'Account/GetUserFeatures',
    timeoutCheck = 'Account/TimeoutCheck',

    mou_GetRobDocument = 'Mou/GetRobDocument',
    mou_SignDocument = 'Mou/SignDocument',

    account_checkEmailDomain = 'Account/CheckEmailDomain',
    account_emailExists = 'Account/EmailExists',
    account_getForgotPassword = 'Account/GetForgotPassword',
    account_changeForgotPassword = 'Account/ChangeForgotPassword',
    account_confirmNewUser = 'Account/ConfirmNewUser',
    account_updateNewUser = 'Account/UpdateNewUser',
    account_Ping = 'Account/Ping',
    account_checkFeature = 'Account/CheckFeature',

    accountRequest_show = 'AccountRequest/Show',
    accountRequest_create = 'AccountRequest/Create',
    accountRequest_showByEmailConfirmationCode = 'AccountRequest/ShowByEmailConfirmationCode',
    accountRequest_updateAccountRequestByEmailConfirmationCode = 'AccountRequest/UpdateAccountRequestByEmailConfirmationCode',
    accountRequest_update = 'AccountRequest/Update',
    accountRequest_createAccountRequestRole = 'AccountRequest/CreateAccountRequestRole',
    accountRequest_updateAccountRequestRole = 'AccountRequest/UpdateAccountRequestRole',
    accountRequest_deleteAccountRequestRole = 'AccountRequest/DeleteAccountRequestRole',
    accountRequest_releaseControlAccountRequest = 'AccountRequest/ReleaseControlAccountRequest',
    accountRequest_signAccountRequest = 'AccountRequest/SignAccountRequest',
    accountRequest_deleteSignAccountRequest = 'AccountRequest/DeleteSignAccountRequest',
    accountRequest_deleteAllSignAccountRequest = 'AccountRequest/DeleteAllSignAccountRequest',
    accountRequest_denyAccountRequest = 'AccountRequest/DenyAccountRequest',
    accountRequest_confirmEmailAddress = 'AccountRequest/ConfirmEmailAddress',
    accountRequest_declineEmailAddress = 'AccountRequest/DeclineEmailAddress',
    accountRequest_resendEmailConfirmationCode = 'AccountRequest/ResendEmailConfirmationCode',
    accountRequest_sendEmailBackToRequester = 'AccountRequest/SendEmailBackToRequester',

    postalAddress_searchCities = 'PostalAddresses/SearchCities',
    postalAddress_searchCitiesById = 'PostalAddresses/SearchCitiesById',
    postalAddress_searchStates = 'PostalAddresses/SearchStates',
    postalAddress_searchStatesById = 'PostalAddresses/SearchStatesById',
    postalAddress_searchCountries = 'PostalAddresses/SearchCountries',
    postalAddress_searchCountriesById = 'PostalAddresses/SearchCountriesById',
    postalAddress_searchZipcodes = 'PostalAddresses/SearchZipcodes',
    postalAddress_searchZipcodesById = 'PostalAddresses/SearchZipcodesById',

    organization_show = 'Organizations/Show',
    organization_getPartyRoles = 'Organizations/GetPartyRoles',
    organization_getCount = 'Organizations/GetCount',
    organization_search = 'Organizations/Search',
    organization_searchNoRegion = 'Organizations/SearchNoRegion',
    organization_searchSchoolDistricts = 'Organizations/SearchSchoolDistricts',
    organization_searchSchools = 'Organizations/SearchSchools',
    organization_searchLegalOrganizations = 'Organizations/SearchLegalOrganizations',
    organization_searchMSINSchools = 'Organizations/SearchMSINSchools',
    organization_searchRegions = 'Organizations/SearchRegions',
    organization_searchAll = 'Organizations/SearchAll',
    organization_searchById = 'Organizations/SearchById',
    organization_searchNone = 'Organizations/SearchNone',
    organization_searchNotARegion = 'Organizations/SearchNotARegion',
    organization_searchRegionByOrganizationName = 'Organizations/SearchRegions2',
    organization_searchSchoolDistrictsInRegion = 'Organizations/SearchSchoolDistrictsInRegion',
    organization_getSchoolByRegionDistrict = 'Organizations/getSchoolByRegionDistrict',
    organization_update = 'Organizations/Update',
    organization_delete = 'Organizations/Delete',
    organization_create = 'Organizations/Create',
    organization_getServiceTypesTable = 'Organizations/GetServiceTypesTable',
    organization_getServiceTypesHierarchiesTable = 'Organizations/GetServiceTypesHierarchies',
    organization_getPartyServiceWithOrgID = 'Organizations/GetPartyServiceWithOrgID',
    organization_getServiceTypeGivenPartyServiceID = 'Organizations/GetServiceTypeGivenPartyServiceID',
    organization_getPartyServices = 'Organizations/GetPartyServices',
    organization_updatePartyServicesRow = 'Organizations/updatePartyServicesRow',
    organization_createPartyServiceRelationships = 'Organizations/CreatePartyServiceRelationships',
    organization_createPartyServiceGradesRow = 'Organizations/CreatePartyServiceGrades',
    organization_createPartyServiceTypesRow = 'Organizations/CreatePartyServiceTypes',
    organization_createServiceTypes = 'Organizations/CreateServiceTypes',
    organization_createServiceTypeHierarchies = 'Organizations/CreateServiceTypeHierarchies',
    organization_createHierarchyServiceType = 'Organizations/createHirarechyServiceType',
    organization_createHierarchy = 'Organizations/CreateHierarchy',
    organization_getPartyServiceDetail = 'Organizations/getPartyServiceDetail',
    organization_SearchSchoolDistrictsInRegion = 'Organizations/SearchSchoolDistrictsInRegion',

    //User Profile
    userProfile_getMyProfile = 'Account/GetMyProfile',
    userProfile_getPartyRoles = 'Persons/GetPartyRoles',
    userProfile_getRegionsByPartyId = 'Regions/GetRegionsByPartyId',
    userProfile_indexPartyRoleTypesByCategory = 'PartyRoles/IndexPartyRoleTypesByCategory',
    userProfile_checkUserId = 'Account/CheckUserId',
    userProfile_changePassword = 'Account/ChangePassword',
    userProfile_updateMyContactInfo = 'Account/UpdateMyContactInfo',

    //CourseHistory
    get_courseTypes = 'CourseHistory/GetCourseTypes',
    get_courseSections = 'CourseHistory/GetCourseSections',
    get_termTypes = 'CourseHistory/GetTermTypes',
    get_schoolEnrollments = 'CourseHistory/GetSchoolEnrollments',

    //Persons
    persons_getPartyRoles = 'Persons/GetPartyRoles',
    persons_getRecruiters = 'Persons/searchRecruiters',

    //Parties
    //parties_getPartyContactMechanisms = 'Parties/GetPartyContactMechanisms',

    //PartyRelationships
    partyRelationships_IndexPartyRelationshipStatusTypes = 'PartyRelationships/IndexPartyRelationshipStatusTypes',

    //PartyRoles
    partyRoles_indexPartyRoleTypesByCategory = 'PartyRoles/IndexPartyRoleTypesByCategory',
    partyRoles_IndexPartyRoleTypes = 'PartyRoles/IndexPartyRoleTypes',
    //ContactMechanisms
    contactMechanisms_indexContactMechanismTypes = 'ContactMechanisms/IndexContactMechanismTypes',
    contactMechanisms_indexContactMechanismPurposeTypes = 'ContactMechanisms/IndexContactMechanismPurposeTypes',
    contactMechanisms_indexGeographicalRegions = 'ContactMechanisms/IndexGeographicalRegions',

    //Dashboard controls End point
    dashboardCategories = 'Dashboard/GetDashboardCategories',
    dashboardWelcomeMessage = 'Dashboard/GetWelcomeMessage',
    dashboardItems = 'Dashboard/GetDashboardItems',
    dashboardExpiredItems = 'Dashboard/GetExpiredDashboardItems',

    //Children -> Search Children
    studentSimpleSearch = 'Student/SimpleSearch',

    //Coe -> Search COE
    coeSimpleSearch = 'Coe/SimpleSearch',
    coeExportData = 'Coe/GetCoeExportData',
    coeBulkExportData = 'Coe/GetCoeBulkExportData',
    coeReviewLogExportData = 'Coe/GetCoeReviewLogExportData',
    coePrintBulkCoesSearch = 'Coe/SearchForPrintReport',
    coePrintBulkExportData = 'COEPrintBulkExportData',
    coePrintBulkCoeAnswers = 'Coe/showCoeAnswersByCoeID',

    coeAnswersByCoeID = 'Coe/showCoeAnswersByCoeID/',
    updateSingleQuestion = 'Coe/UpdateSingleQuestion',
    createCOEID = 'Coe/getNewCoeSurveyIDByDocType',
    createExistingCoeId = 'Nodes/CreateExistingCoeID',
    createCoeNumber = 'preScreening/CreateCoeWizardV3',
    createProvSchool = 'Coe/createProvSchool',
    sendToReviewQueue = 'Nodes/CreateExistingCoeIDSendToReviewV2',
    getQuestionComments = 'QuestionComments/Index',
    saveQuestionComment = 'QuestionComments/Create',
    getCommentsByNodeId = 'Nodes/GetComments',
    saveCommentByNodeId = 'Comments/Create',
    updateCommentByNodeId = 'Comments/Update',
    deleteCommentByNodeId = 'Comments/Delete',
    getSurveyIDByCoeID = 'Coe/getSurveyIDByCoeID',
    saveCoeReview = 'CoeReview/Create',
    getCoeReviewData = 'Coe/getCoeReviewData',
    isCoeWizard = 'Coe/isCoeWizard',
    sendToSelfReviewQueue = 'Nodes/CreateExistingCoeIDSendToSelfReview',
    setChildCoeIneligible = 'Coe/SetChildCoeIneligible',
    setCoeIneligible = 'Coe/SetCoeIneligible',
    createCoeV2 = 'Coe/CreateCoeV2',
    sendEmailToRecruiterFixState = 'Coe/SendEmailToRecruiterFixState',
    getNodeForCoe = 'Coe/getNodeForCoe',

    //Schools -> Search Schools
    schools = 'Schools/SimpleSearch',
    schoolDistricts = 'Schools/SearchSchoolDistricts', // 'ActiveStudentLists/IndexSchoolDistricts', //'Schools/SearchSchoolDistricts',
    indexSchoolDistricts = 'ActiveStudentLists/IndexSchoolDistricts',
    extendedSearch = 'ActiveStudentLists/ExtendedSearch',
    parties_getPartyContactMechanisms = 'Parties/GetPartyContactMechanisms',
    parties_getContactMechanismPurposeTypes = 'Parties/GetPartyContactMechanismPurposeTypes',
    parties_getPartyRoleTypeByCategory = 'PartyRoles/IndexPartyRoleTypesByCategory',
    schoolGradesTable = 'Organizations/GetGradesTable',
    schoolTypeOther = 'Schools/getSchoolTypeOther',
    schoolStatus = 'Schools/getSchoolStatus',
    schoolCheckCode = 'Schools/checkSchoolCode',
    schoolCheckNCESDistrictCode = 'Schools/CheckSchoolDistrictNCES',
    schoolUpdateGeneralInfo = 'Schools/UpdateSchoolGeneralInfo',
    schoolUpdateContactInfo = 'Schools/UpdateSchoolContactInformation',
    schoolUpdateDistrict = 'Schools/UpdateSchoolDistrict',
    schoolUpdateLocation = 'Schools/UpdateSchoolLocation',
    schoolShow = 'Schools/Show',
    //Schools -> Create
    schoolCreateNew = 'Schools/CreateNewSchool',
    schoolSearchCities = 'PostalAddresses/SearchCities',

    // system
    systemSchoolSearchDistricts = 'SchoolDistricts/Search',
    systemGetUserSchoolDistricts = 'Account/GetUserSchoolDistricts',
    systemSchoolDistrictShow = 'SchoolDistricts/Show',
    schoolDistrictsUpdateGeneralInfo = 'SchoolDistricts/UpdateSchoolDistrictGeneralInfo',
    schoolDistrictsUpdateLocation = 'SchoolDistricts/UpdateSchoolDistrictLocation',
    systemSchoolDistrictsCreate = 'SchoolDistricts/Create',
    systemSearchCounty = 'Counties/Search',
    systemUpdateCountyLocation = 'Counties/UpdateCountyLocation',
    systemUpdateCountyGeneralInfo = 'Counties/UpdateCountyGeneralInfo',
    systemCreateCounty = 'Counties/Create',
    systemShowCounty = 'Counties/Show',
    //Common Controls End point

    getRegionsByPartyId = 'Regions/GetRegionsByPartyId',
    region = 'Organizations/IndexRegions',
    organizations = 'Organizations/Index',
    county = 'ActiveStudentLists/IndexCounties',
    school_indexSchools = 'ActiveStudentLists/IndexSchools',
    role = 'Roles/Index',
    delete_contactMechanism = 'ContactMechanisms/Delete',
    create_contactMechanism = 'ContactMechanisms/Create',
    createAll_contactMechanism = 'ContactMechanisms/CreateAll',
    update_contactMechanism = 'ContactMechanisms/Update',
    //GetQuestionHelpTexts/Batch
    questionHelpText = 'QuestionHelpTexts',

    //Child Reports -> Count
    unduplicatedStudentEligibilities = 'StudentEligibilityLists/GetUnduplicatedStudentEligibilitiesCountByRegion',
    studentEligibilityCount = 'StudentEligibilityLists/GetStudentEligibilityCount',
    unduplicatedStudentEligibilityCount = 'StudentEligibilityLists/GetUnduplicatedStudentEligibilityCount',
    studentEligibilityCountExcel = 'StudentEligibilityLists/GetStudentEligibilityCountExcel',
    getStudentsByEligibilityCategory = 'StudentEligibilityLists/GetStudentsByEligibilityCategory',
    //Child Reports -> Graduation Report
    graduationReport_search = 'StudentGraduationLists/Search',

    //Child Reports -> Service Report
    studentServiceLists_GetStudentServiceListCount = 'StudentServiceLists/GetStudentServiceListCount',
    studentServiceLists_GetStudentsByPartyService = 'StudentServiceLists/GetStudentsByPartyService',

    //Child Reports -> Academic Risk Report
    academicRiskReport_search = 'AcademicRiskReport/Search',

    //Child Reports -> PFS Report
    pfsReport_search = 'PfsList/Search',

    //Child Reports -> CourseHistory
    get_CourseHistory = 'CourseHistory/Index',
    create_CourseHistory = 'CourseHistory/Create',
    delete_CourseHistory = 'CourseHistory/Delete',
    update_CourseHistory = 'CourseHistory/Update',

    get_CourseHistory_SchoolEnrollments = 'CourseHistory/GetSchoolEnrollments',
    //Child Reports -> CourseHistory

    //INA/ILP
    inaReports_searchINAReports = 'INAReports/SearchINAReports',
    get_INA_SchoolEnrollments = 'INASchoolEnrollments/GetINA',
    get_INA = 'INASchoolEnrollments/GetINASchoolEnrollments',
    get_INA_History = 'INAAnswer/GetINAHistory',
    update_INA = 'INAAnswer/UpdateINAAnswers',
    delete_INA = 'INASchoolEnrollments/DeleteINASchoolEnrollments',
    create_INA = 'INASchoolEnrollments/CreateINASchoolEnrollments',
    create_INA_History = 'INAAnswer/CreateINAHistory',
    //Data Monitoring (Data Completeness) Report
    // Grade Age Alignment
    gradeAgeAlignment_search = 'GradeAgeAlignment/Search',
    gradeAgeAlignment_searchMinified = 'GradeAgeAlignment/SearchMinified',
    // Enrollments
    dataMonitoring_GetREnrolledMissingSsid = 'DataCompletenessReport/GetREnrolledMissingSsid',
    dataMonitoring_getDuplicateREnrollmentLine = 'DataCompletenessReport/getDuplicateREnrollmentLine',
    dataMonitoring_GetEIPNoEnrollment = 'DataCompletenessReport/GetEIPNoEnrollment',
    dataMonitoring_GetEligibleEnrolledNotServed = 'DataCompletenessReport/GetEligibleEnrolledNotServed',
    dataMonitoring_GetMissingWithdrawalDate = 'DataCompletenessReport/GetMissingWithdrawalDate',
    dataMonitoring_GetProvisionalSchool = 'DataCompletenessReport/GetProvisionalSchools',
    dataMonitoring_GetNEnrollmentNotEip = 'DataCompletenessReport/GetNEnrollmentNotEip',
    dataMonitoring_getQadAgeEligible = 'DataCompletenessReport/getQadAgeEligible',
    dataMonitoring_GetREnrollmentNotEip = 'DataCompletenessReport/GetREnrollmentNotEip',
    // Services
    dataMonitoring_getDuplicateService = 'DataCompletenessReport/getDuplicateService',
    dataMonitoring_GetMissingDepartureDateAndSummerIntersessionService = 'DataCompletenessReport/GetMissingDepartureDateAndSummerIntersessionService',
    dataMonitoring_getMissingServiceEndDate = 'DataCompletenessReport/getMissingServiceEndDate',
    dataMonitoring_ServiceDatesGreaterThan12Months = 'DataCompletenessReport/ServiceDatesGreaterThan12Months',

    // Service Delivery
    serviceDelivery_Show = 'ServiceDelivery/Show',
    serviceDelivery_getEnrollmentPeriods = 'ServiceDelivery/getEnrollmentPeriods',
    serviceDelivery_getServiceCategory = 'ServiceDelivery/getServiceCategory',
    serviceDelivery_getStudentServices = 'ServiceDelivery/getStudentServices',
    serviceDelivery_getStudentProvisionalServices = 'ServiceDelivery/getStudentProvisionalServices',
    serviceDelivery_getCOSResons = 'ServiceDelivery/getCOSResons',
    serviceDelivery_getStudentEnrollmentsBySchoolDestrictScYrV2 = 'ServiceDelivery/getStudentEnrollmentsBySchoolDestrictScYrV2',
    serviceDelivery_CreateServiceDelivery = 'ServiceDelivery/CreateServiceDelivery',
    serviceDelivery_deleteByID = 'ServiceDelivery/deleteByID',
    serviceDelivery_editServiceDelivery = 'ServiceDelivery/EditServiceDelivery',
    serviceDelivery_editServiceDeliveryDates = 'ServiceDelivery/EditServiceDeliveryDates',

    // Service Administration
    serviceAdministration_Index = 'ServiceAdministration/Index',
    serviceAdministration_Show = 'ServiceAdministration/Show',
    serviceAdministration_GetStateServices = 'ServiceAdministration/GetStateServices',
    serviceAdministration_GetMeasurableProgramObjectives = 'ServiceAdministration/GetMeasurableProgramObjectives',
    serviceAdministration_GetFederalCategories = 'ServiceAdministration/GetFederalCategories',
    serviceAdministration_IndexSSDPComponents = 'ServiceAdministration/IndexSSDPComponents',
    serviceAdministration_IndexServiceHours = 'ServiceAdministration/IndexServiceHours',
    serviceAdministration_IndexServiceCategories = 'ServiceAdministration/IndexServiceCategories',
    serviceAdministration_IndexServiceProviders = 'ServiceAdministration/IndexServiceProviders',
    serviceAdministration_IndexPartyServiceStatusTypes = 'ServiceAdministration/IndexPartyServiceStatusTypes',
    serviceAdministration_Create = 'ServiceAdministration/Create',
    serviceAdministration_Update = 'ServiceAdministration/Update',
    serviceAdministration_Delete = 'ServiceAdministration/Delete',
    serviceAdministration_DeleteCheck = 'ServiceAdministration/DeleteCheck',
    serviceAdministration_ToggleStatus = 'ServiceAdministration/ToggleStatus',

    //Tracking History
    trackingHistory_Index = 'TrackingHistory/Index',
    trackingHistory_Create = 'TrackingHistory/Create',

    //SSDP Reports
    mpo = 'SSDP/Report',
    mpoReportDetailed = 'SSDP/ReportDetailed',
    searchStudent = 'SSDP/searchSSDPStudent',

    sdpmpo = 'SDP/Report',

    //DTMon Reports
    dtMonGradeAge = 'GradeAgeAlignment/Search',

    //System
    accounts_search = 'Account/SearchV2',
    accounts_show = 'Account/Show',
    accounts_password_change_information = 'Account/GetPasswordChangeInformation',
    accounts_loginDetailStatus = 'Account/IndexLoginDetailStatusTypes',
    accounts_update_contactInfo = 'Account/UpdateAccountContactInfo',
    accounts_update_status = 'Account/UpdateAccountStatus',
    accounts_update_Organization = 'Account/UpdateRegionOrganization',
    accounts_update_UserRoles = 'Account/UpdateUserRoles',
    acounts_post_loginAudit = 'Account/IndexLoginAudits',
    account_register = 'Account/Register',
    accounts_roles = '',
    accounts_features = '',
    accounts_SessionCount = 'Super/GetSessionCount',
    accounts_ResetPassword = 'Super/ResetPassword',
    accounts_RemoveSessions = 'Super/RemoveSessions',
    accounts_RemoveOtherSessions = 'Account/RemoveOtherSessions',
    accounts_ReCreateNewUser = 'Super/ReCreateNewUser',
    accounts_checkAccountStatus = 'Account/CheckAccountStatus',

    subgranteeStatePerformance = 'SSDPAnnualReports/SearchSsdpSubgranteeStatePerformance',
    subgranteeMPO = 'SSDPAnnualReports/SearchSsdpSubgranteeMPO',

    //System Roles
    roles_Index = 'Roles/Index',
    roles_Create = 'Roles/Create',
    roles_Update = 'Roles/Update',
    roles_Delete = 'Roles/Delete',

    //System Features
    features_Index = 'Features/Index',
    features_Create = 'Features/Create',
    features_Update = 'Features/Update',
    features_Delete = 'Features/Delete',
    features_hierarchy_Index = 'Features/Hierarchy/Index',
    features_hierarchy_Create = 'Features/Hierarchy/Create',
    features_hierarchy_DeleteOne = 'Features/Hierarchy/DeleteOne',
    features_hierarchy_DeleteAll = 'Features/Hierarchy/DeleteAll',

    //System Permissions
    permissions_Index = 'Permissions/Index',
    permissions_Create = 'Permissions/Create',
    permissions_Delete = 'Permissions/Delete',
    statePermissions_Index = 'StatePermissions/Index',
    statePermissions_Create = 'StatePermissions/Create',
    statePermissions_Delete = 'StatePermissions/Delete',

    //Workflows
    workflows_Index = 'Workflows/Index',
    workflows_GetWorkflowStates = 'Workflows/GetWorkflowStates',
    workflows_Show = 'Workflows/Show',
    workflows_Update = 'Workflows/Update',
    workflows_GetWorkflowNodeTypes = 'Workflows/GetWorkflowNodeTypes',
    workflows_GetWorkflowTransitions = 'Workflows/GetWorkflowTransitions',
    workflows_GetWorkflowRoles = 'Workflows/GetWorkflowRoles',
    workflows_GetMyWorkflows = 'Workflows/GetMyWorkflows',
    workflows_GetInboxStates = 'Workflows/GetInboxStates',
    workflows_GetInProgressStates = 'workflows/GetInProgressStates',
    workflows_GetArchiveStates = 'workflows/GetArchiveStates',
    workflows_GetOutboxStates = 'workflows/GetOutboxStates',
    workflows_GetWorkflowStateNodes = 'workflows/GetWorkflowStateNodes',
    workflows_GetCreateInProgressStatus = 'workflows/GetCreateInProgressStatus',
    workflows_GetInboxNodesCount = 'workflows/GetInboxNodesCount',
    workflows_GetInProgressNodesCount = 'workflows/GetInProgressNodesCount',
    workflows_GetOutboxNodesCount = 'workflows/GetOutboxNodesCount',
    workflows_GetMyTransitions = 'Workflows/GetMyTransitions',
    workflows_GetWorkFlowStateTypesByStateNameWorkflowName = 'Workflows/GetWorkFlowStateTypesByStateNameWorkflowName',

    //Transitions
    transitions_IndexTransitionPropertyTypes = 'Transitions/IndexTransitionPropertyTypes',
    transitions_Create = 'Transitions/Create',
    transitions_Delete = 'Transitions/Delete',
    transitions_CreateTransitionProperty = 'Transitions/CreateTransitionProperty',
    transitions_DeleteTransitionProperty = 'Transitions/DeleteTransitionProperty',
    transitions_ToggleTransitionRegion = 'Transitions/ToggleTransitionRegion',
    transitions_IndexUsersByRegion = 'Transitions/IndexUsersByRegion',
    transitions_IndexFixedUsersByRegion = 'Transitions/IndexFixedUsersByRegion',

    //States
    workflow_states_Create = 'States/Create',
    workflow_states_Update = 'States/Update',
    workflow_states_Delete = 'States/Delete',

    //Email Domains
    emailDomains_Index = 'EmailDomains/Index',
    emailDomains_Search = 'EmailDomains/Search',
    emailDomains_Create = 'EmailDomains/Create',
    emailDomains_Update = 'EmailDomains/Update',
    emailDomains_Delete = 'EmailDomains/Delete',

    //Student
    student_Show = 'Student/Show',
    student_GetCoesDetailed = 'Student/GetCoesDetailed',
    student_GetStudentBirthAddress = 'Student/GetStudentBirthAddress',
    student_GetParents = 'Student/GetParents',
    student_GetIdentifiers = 'Student/GetIdentifiers',
    student_GetPreferredInfo = 'Student/GetPreferredInfo',
    student_ShowActiveStudent = 'Student/ShowActiveStudent',
    student_GetLegalMother = 'Student/GetLegalMother',
    student_CheckExistingStudentSSID = 'Student/CheckExistingStudentSSID',
    student_GetParentsFromCoes = 'Student/GetParentsFromCoes',
    student_CreateStudentTerminationStatus = 'Student/CreateStudentTerminationStatus',
    student_GetGroupCurrentStudentTerminationStatuses = 'Student/GetGroupCurrentStudentTerminationStatuses',
    student_GetCoeRelatedStudents = 'Student/GetCoeRelatedStudents',
    student_GetCoeRelatedStudentsByContactMechanism = 'Student/GetCoeRelatedStudentsByContactMechanism',
    student_getAssessmentsDetails = 'Student/getAssessmentsDetails',
    student_VerifyCoe = 'Student/VerifyCoe',

    student_Search = 'Student/Search',
    student_SimpleSearch = 'Student/SimpleSearch',
    student_SimpleSearchSeparateBirthCity = 'Student/SimpleSearchSeparateBirthCity',
    student_SimpleSearchStarCount = 'Student/SimpleSearchStarCount',
    student_SimpleSearchStarLazy = 'Student/SimpleSearchStarLazy',

    student_Update = '/Student/Update',
    student_updateParents = 'Student/updateParents',
    student_CreateIDNew = 'Student/CreateIDNew',
    student_DeleteStudentIdentifier = 'Student/DeleteStudentIdentifier',
    student_AddBirthAddress = 'Student/AddBirthAddress',
    student_UpdateBirthAddress = 'Student/UpdateBirthAddress',
    student_UpdateStudentContactInformation = 'Student/UpdateStudentContactInformation',
    student_UpdateStudentIdentifier = 'Student/UpdateStudentIdentifier',
    student_DeleteStudentIdentifier2 = 'Student/DeleteStudentIdentifier2',
    student_EditPreferredInfo = 'Student/EditPreferredInfo',

    //StudentTerminations
    studentTerminations_GetStudentTerminationStatusHistory = 'StudentTerminations/GetStudentTerminationStatusHistory',
    studentTerminations_GetStudentTerminationStatusTypes = 'StudentTerminations/GetStudentTerminationStatusTypes',
    studentTerminations_GetSchoolEnrollments = 'StudentTerminations/GetSchoolEnrollments',
    studentTerminations_Create = 'StudentTerminations/Create',
    studentTerminations_Delete = 'StudentTerminations/DELETE',

    //StudentEligibilities
    studentEligibilities_IndexEligibilityChangeReasonTypes = 'StudentEligibilities/IndexEligibilityChangeReasonTypes',
    studentEligibilities_IndexEligibilityStatuses = 'StudentEligibilities/IndexEligibilityStatuses',
    studentEligibilities_GetStudentEligibilities = 'StudentEligibilities/GetStudentEligibilities',
    studentEligibilities_IndexEligibilityCategoryTypes = 'StudentEligibilities/IndexEligibilityCategoryTypes',
    studentEligibilities_GetLatestCoeAndEligiblity = 'StudentEligibilities/GetLatestCoeAndEligiblity',
    studentEligibilities_GetStudentEligibilityByCategory = 'StudentEligibilities/GetStudentEligibilityByCategory',
    studentEligibilities_GetEiPReason = 'StudentEligibilities/GetEiPReason',

    //StudentSchoolEnrollment
    studentSchoolEnrollment_GetSchoolEnrollments = 'StudentSchoolEnrollment/GetSchoolEnrollments',
    studentSchoolEnrollment_GetProvisionalSchoolEnrollments = 'StudentSchoolEnrollment/GetProvisionalSchoolEnrollments',
    studentSchoolEnrollment_GetSchoolEnrollmentDetailTypes = 'StudentSchoolEnrollment/GetSchoolEnrollmentDetailTypes',
    studentSchoolEnrollment_GetNextSchoolEnrollment = 'StudentSchoolEnrollment/GetNextSchoolEnrollment',
    studentSchoolEnrollment_GetSchoolEnrollmentDetails = 'StudentSchoolEnrollment/GetSchoolEnrollmentDetails',
    studentSchoolEnrollment_GetSchoolEnrollmentComments = 'StudentSchoolEnrollment/GetSchoolEnrollmentComments',
    studentSchoolEnrollment_CreateV2 = 'StudentSchoolEnrollment/CreateV2',
    studentSchoolEnrollment_Update = 'StudentSchoolEnrollment/Update',
    studentSchoolEnrollment_UpdateMultiple = 'StudentSchoolEnrollment/UpdateMultiple',
    studentSchoolEnrollment_GetServicesForSchoolEnrollment = 'StudentSchoolEnrollment/GetServicesForSchoolEnrollment',
    studentSchoolEnrollment_GetOtherSchoolsInSameSchoolYear = 'StudentSchoolEnrollment/GetOtherSchoolsInSameSchoolYear',
    studentSchoolEnrollment_GetSchoolEnrollmentCoes = 'StudentSchoolEnrollment/GetSchoolEnrollmentCoes',
    studentSchoolEnrollment_Delete = 'StudentSchoolEnrollment/Delete',
    studentSchoolEnrollment_Promote = 'StudentSchoolEnrollment/Promote',
    studentSchoolEnrollment_Graduate = 'StudentSchoolEnrollment/Graduate',

    //StudentCommunicationEvents
    studentCommunicationEvents_GetCommunicationEventPurposeTypes = 'StudentCommunicationEvents/GetCommunicationEventPurposeTypes',
    studentCommunicationEvents_GetStudentCommunicationEvents = 'StudentCommunicationEvents/GetStudentCommunicationEvents',
    studentCommunicationEvents_Create = 'StudentCommunicationEvents/Create',
    studentCommunicationEvents_Update = 'StudentCommunicationEvents/Update',
    studentCommunicationEvents_Delete = 'StudentCommunicationEvents/Delete',
    studentCommunicationEvents_GetStudentsWithSameCommunicationEvent = 'StudentCommunicationEvents/GetStudentsWithSameCommunicationEvent',
    studentCommunicationEvents_GetCommunicationEventsReport = 'StudentCommunicationEvents/GetCommunicationEventsReport',

    //StudentDeduplication
    studentDeduplication_GetDuplicatesCount = 'StudentDeduplication/GetDuplicatesCount',
    studentDeduplication_IndexDuplicateResolutionTypes = 'StudentDeduplication/IndexDuplicateResolutionTypes',
    studentDeduplication_IndexDuplicateResolutionStudentPropertyTypes = 'StudentDeduplication/IndexDuplicateResolutionStudentPropertyTypes',
    studentDeduplication_IndexDuplicateResolutionStudentStatuses = 'StudentDeduplication/IndexDuplicateResolutionStudentStatuses',
    studentDeduplication_GetUnresolvedDuplicatesByRegion = 'StudentDeduplication/GetUnresolvedDuplicatesByRegion',
    studentDeduplication_GetResolvedDuplicatesByRegion = 'StudentDeduplication/GetResolvedDuplicatesByRegion',
    studentDeduplication_UpdateDuplicateResolutionType = 'StudentDeduplication/UpdateDuplicateResolutionType',
    studentDeduplication_ResolveDuplicateResolutionMerged = 'StudentDeduplication/ResolveDuplicateResolutionMerged',
    studentDeduplication_ResolveDuplicateResolutionDifferent = 'StudentDeduplication/ResolveDuplicateResolutionDifferent',
    studentDeduplication_ShowDuplicateResolution = 'StudentDeduplication/ShowDuplicateResolution',
    studentDeduplication_RevertDuplicateResolutionMerged = 'StudentDeduplication/RevertDuplicateResolutionMerged',
    studentDeduplication_RevertDuplicateResolutionDifferent = 'StudentDeduplication/RevertDuplicateResolutionDifferent',
    studentDeduplication_AddDuplicateResolution = 'StudentDeduplication/AddDuplicateResolution',
    studentDeduplication_GetStudentMergedTree = 'StudentDeduplication/getStudentMergedTree',
    studentDeduplication_ShowResolvedDuplicatesByStudentId = 'StudentDeduplication/ShowResolvedDuplicatesByStudentId',

    //StudentIdentifierType
    studentIdentifierType_GetIdentifierTypes = 'StudentIdentifierType/GetIdentifierTypes',

    //INASchoolEnrollments
    inaSchoolEnrollments_GetINASchoolEnrollments = 'INASchoolEnrollments/GetINASchoolEnrollments',

    //Nodes
    nodes_Show = 'Nodes/Show',
    nodes_GetEditors = 'Nodes/GetEditors',
    nodes_GetHistories = 'Nodes/GetHistories',
    nodes_chooseToEditNode = 'Nodes/ChooseToEditNode',
    nodes_chooseToNotEditNode = 'Nodes/ChooseToNotEditNode',
    nodes_Transition = 'Nodes/Transition',
    nodes_TransitionByName = 'Nodes/TransitionByName',
    nodes_GetComments = 'Nodes/GetComments',
    nodes_GetUsersInMyRegion = 'Nodes/GetUsersInMyRegion',
    nodes_ReassignNode = 'Nodes/ReassignNode',
    nodes_RemoveEditor = 'Nodes/RemoveEditor',
    nodes_GetWorkflowStates = 'Nodes/GetWorkflowStates',
    nodes_ChangeNodeState = 'Nodes/ChangeNodeState',

    //Comments
    comments_Create = 'Comments/Create',
    comments_Update = 'Comments/Update',
    comments_Delete = 'Comments/Delete',

    //ProvisionalSchools
    provisionalSchools_Show = 'ProvisionalSchools/Show',
    provisionalSchools_ShowByNodeId = 'ProvisionalSchools/ShowByNodeId',
    provisionalSchools_Update = 'ProvisionalSchools/Update',
    provisionalSchools_UpdateCoeAnswers = 'ProvisionalSchools/UpdateCoeAnswers',
    provisionalSchools_ResolveProvisionalSchool = 'ProvisionalSchools/ResolveProvisionalSchool',

    // apiMsinExports
    apiMsinExportsPDF = '',
    apiMsinExportsXLS = '',
    apiUrlMsinExportsSSDPAnnualAPI = '',
    apiMsinExportsSSDPGeneral = '',

    // sessionTracker
    apiSessionTrack = 'SessionTracker',
    apiSessionTrackNextId = 'SessionTracker/nextidendpoint',

    // helpText
    apiHelpText = 'HelpText',
    apiHelpTextIndex = 'HelpTextIndex',
    apiHelpTextTag = 'HelpTextTag',
    apiBuildVersion = 'ActionRun/data',
    nodes_deleteCoe = 'Coe/Delete',
    serviceDelivery_Report = 'ServiceDelivery/Show/',

    // calpadsSsidResolutions
    get_CalpadSSIDResolution_OverallCounts = 'CalpadsSsidResolutions/GetOverallCounts',
    get_CalpadSSIDResolution_UnresolvedCounts = 'CalpadsSsidResolutions/GetUnresolvedSummaryByRegion/',
    get_CalpadSSIDResolution_ResolvedCounts = 'CalpadsSsidResolutions/GetResolvedSummaryByRegion/',
    get_CalpadSSIDResolution_StudentInfo = 'CalpadsSsidResolutions/GetStudentInfo',
    get_CalpadSSIDResolution_ResolvedStudent = 'CalpadsSsidResolutions/getResolvedStudentAll',
    get_CalpadSSIDResolution_UnresolvedStudent = 'CalpadsSsidResolutions/GetUnresolvedStudent',
    post_calpadSSIDResolution = 'CalpadsSsidResolutions/Resolve',
    post_calpadSSIDNoMatch = 'CalpadsSsidResolutions/ResolveNoMatch',
    get_CalpadSSIDResolution_PreviousSSID = 'CalpadsSsidResolutions/GetPreviousSsid',
    calpadsSsidResolutions_GetResolvedSummaryForStudent = 'CalpadsSsidResolutions/GetResolvedSummaryForStudent',
    calpadsSsidResolutions_GetUnresolvedStudent = 'CalpadsSsidResolutions/GetUnresolvedStudent',
    calpadsSsidResolutions_GetResolvedStudent = 'CalpadsSsidResolutions/GetResolvedStudent',
    calpadsSsidResolutions_GetResolvedStudentAll = 'CalpadsSsidResolutions/GetResolvedStudentAll',
    calpadsSsidResolutions_Resolve = 'CalpadsSsidResolutions/Resolve',
    calpadsSsidResolutions_ResolveNoMatch = 'CalpadsSsidResolutions/ResolveNoMatch',
    calpadsSsidResolutions_GetHistory = 'CalpadsSsidResolutions/GetHistory',
    calpadsSsidResolutions_GetHistoryAll = 'CalpadsSsidResolutions/GetHistoryAll'
}

@Injectable({
    providedIn: 'root'
})
export class UrlProviderService {
    constructor() {}

    getUrl(endpoint: EndPoints, mode?: string, params?: string, queryParams?: string): string {
        let url: string = endpoint;

        if (mode && !url.endsWith('.json')) {
            url = url;
        }

        // Custom code for Demo remove later
        if (url.endsWith('.json')) {
            return url;
        }

        if (url.startsWith('http')) {
            return url;
        }

        if (queryParams) {
            return `${environment.apiUrl}${url}/${queryParams}`;
        }

        return `${environment.apiUrl}${url}`;
    }

    getUrl2(endpoint: EndPoints, mode?: string, params?: string, queryParams?: string): string {
        let url: string = endpoint;

        if (mode && !url.endsWith('.json')) {
            url = url;
        }

        // Custom code for Demo remove later
        if (url.endsWith('.json')) {
            return url;
        }

        if (url.startsWith('http')) {
            return url;
        }

        if (queryParams) {
            return `${environment.apiUrlMsinExportsAPI}/SSDPReport${url}/${queryParams}`;
        }

        return `${environment.apiUrlMsinExportsAPI}/SSDPReport${url}`;
    }

    getUrl2SSDPGeneral(endpoint: EndPoints, mode?: string, params?: string, queryParams?: string): string {
        let url: string = endpoint;

        if (mode && !url.endsWith('.json')) {
            url = url;
        }

        // Custom code for Demo remove later
        if (url.endsWith('.json')) {
            return url;
        }

        if (url.startsWith('http')) {
            return url;
        }

        if (queryParams) {
            return `${environment.apiUrlMsinExportsAPI}/SSDPGeneral${url}/${queryParams}`;
        }

        return `${environment.apiUrlMsinExportsAPI}/SSDPGeneral${url}`;
    }

    getUrlNoQueryParam(): string {
        return `${environment.apiUrlMsinExportsAPI}/SSDPReport`;
    }

    getUrlNoQueryParamAnnualSSDP(): string {
        return `${environment.apiUrlMsinExportsAPI}/SSDPAnnualReports`;
    }

    getUrl4GeneralSSDP(endpoint: EndPoints): string {
        let url: string = endpoint;

        return `${environment.apiUrlMsinExportsAPI}/SSDPGeneral`;
    }

    getUrlSdpStudentsExport(): string {
        return `${environment.apiUrlMsinExportsAPI}/SDPReport/Students`;
    }

    getUrl4DtMonGradeAgeAlignment(exportType: string): string {
        return `${environment.apiUrlMsinExportsAPI}/DtMonGradeAgeAlignment/${exportType}`;
    }

    getUrlCoeSearchPDF(): string {
        return `${environment.apiUrlMsinExportsAPI}/Coe`;
    }

    getUrl4DtMonEnrollmentsPDF(): string {
        return `${environment.apiUrlMsinExportsAPI}/DtMonEnrollments`;
    }

    getUrl4DtMonGradeAgePDF(): string {
        return `${environment.apiUrlMsinExportsAPI}/DtMonGradeAgeSearch`;
    }

    getUrl4DtMonEnrollmtsAndService(): string {
        return `${environment.apiUrlMsinExportsAPI}/DtMonEnrollmtTypeAndService`;
    }

    getUrl4DtMonSimplifiedEnrollmt(): string {
        return `${environment.apiUrlMsinExportsAPI}/DtMonSimplifiedEnrollmt`;
    }

    getUrl4DtMonEnrollmentsXLS(): string {
        return `${environment.apiUrlMsinExportsAPI}/DtMonEnrollments`;
    }

    getUrlCoeSearchXLS(): string {
        return `${environment.apiUrlMsinExportsAPI}/Coe`;
    }

    getUrlChildCountsRegionalExportData(): string {
        return `${environment.apiUrlMsinExportsAPI}/ChildReports`;
    }

    getUrlChildCountsExportData(): string {
        return `${environment.apiUrlMsinExportsAPI}/ChildReports`;
    }

    getUrlEnrollmentsExportData(): string {
        return `${environment.apiUrlMsinExportsAPI}/Enrollments`;
    }

    getUrlServiceReportsExportData(): string {
        return `${environment.apiUrlMsinExportsAPI}/ServiceReports`;
    }

    getUrlAcademicRiskExportData(): string {
        return `${environment.apiUrlMsinExportsAPI}/AcademicRisk`;
    }

    getInaPdfExportData(): string {
        return `${environment.apiUrlMsinExportsAPI}/InaPdf`;
    }

    getUrlCommunicationEventExportData(): string {
        return `${environment.apiUrlMsinExportsAPI}/CommunicationEvent`;
    }

    getUrlPFSExportData(): string {
        return `${environment.apiUrlMsinExportsAPI}/PFS`;
    }

    getUrlGraduationExportData(): string {
        return `${environment.apiUrlMsinExportsAPI}/GraduationReport`;
    }

    getUrlInaExportData(): string {
        return `${environment.apiUrlMsinExportsAPI}/InaIlp`;
    }

    getUrlInaViewPrintExportData(): string {
        return `${environment.apiUrlMsinExportsAPI}/InaViewPrint`;
    }

    getUrlInaViewExportData(): string {
        return `${environment.apiUrlMsinExportsAPI}/InaView`;
    }

    getUrlCoeReviewLogExportData(): string {
        return `${environment.apiUrlMsinExportsAPI}/COEReviewLogExportData`;
    }

    getUrlCoeExportData(): string {
        return `${environment.apiUrlMsinExportsAPI}/COEExportData`;
    }

    getUrlCoePrintBulkExportData(): string {
        return `${environment.apiUrlMsinExportsAPI}/COEPrintBulkExportData/export-print-bulk-coe`;
    }

    getUrlCoePrintBulkViewData(): string {
        return `${environment.apiUrlMsinExportsAPI}/COEPrintBulkExportData/viewer-print-bulk-coe`;
    }

    getUrlCountsRegionReport(): string {
        return `${environment.apiUrlMsinExportsAPI}/CountsReport/Regions`;
    }

    getUrlCountsSchoolDistrictReport(): string {
        return `${environment.apiUrlMsinExportsAPI}/CountsReport/SchoolDistricts`;
    }

    getUrlCountsStudentsReport(): string {
        return `${environment.apiUrlMsinExportsAPI}/CountsReport/Students`;
    }

    getUrlDataMonitoringReport(): string {
        return `${environment.apiUrlMsinExportsAPI}/DataMonitoringReports`;
    }

    getUrlNoQueryParamViaPost(endpoint: EndPoints): string {
        let url: string = endpoint;

        return `${environment.apiUrlMsinExportsAPI}/SSDPReport`;
    }

    getUrlNoQueryParamViaPostSSDPGeneral(endpoint: EndPoints): string {
        let url: string = endpoint;

        return `${environment.apiUrlMsinExportsAPI}/SSDPGeneral`;
    }

    getUrl3(endpoint: EndPoints, queryParamString?: string): string {
        let url: string = endpoint;

        console.log('calling getUrl3.5');
        console.log(queryParamString);
        if (queryParamString) {
            console.log('got queryParams. Returning:');
            console.log(`${environment.apiUrlMsinExportsAPI}/SSDPReport${url}${queryParamString}`);
            return `${environment.apiUrlMsinExportsAPI}/SSDPReport${url}${queryParamString}`;
        }

        return `${environment.apiUrlMsinExportsAPI}/SSDPReport${url}`;
    }

    getUrlSessionTrack(endpoint: EndPoints, mode?: string, params?: string, queryParams?: string): string {
        let url: string = endpoint;

        if (mode && !url.endsWith('.json')) {
            url = url;
        }

        // Custom code for Demo remove later
        if (url.endsWith('.json')) {
            return url;
        }

        if (url.startsWith('http')) {
            return url;
        }

        if (queryParams) {
            return `${environment.apiUrlMSINCatalogAPI}${url}?${queryParams}`;
        }

        return `${environment.apiUrlMSINCatalogAPI}${url}`;
    }

    getUrlMSINCatalog(endpoint: EndPoints, mode?: string, params?: string, queryParams?: string): string {
        let url: string = endpoint;

        if (mode && !url.endsWith('.json')) {
            url = url;
        }

        // Custom code for Demo remove later
        if (url.endsWith('.json')) {
            return url;
        }

        if (url.startsWith('http')) {
            return url;
        }

        if (queryParams) {
            return `${environment.apiUrlMSINCatalogAPI}${url}?${queryParams}`;
        }

        return `${environment.apiUrlMSINCatalogAPI}${url}`;
    }

    /*getUrlSessionTrack(endpoint: EndPoints, queryParamString?: string): string {
        let url: string = endpoint;

        console.log('calling getUrlSessionTrack');
        console.log(queryParamString);
        if (queryParamString) {
            console.log('got queryParams. Returning:');            
            console.log(`${environment.apiUrlMSINCatalogAPI}${url}?${queryParamString}`); //${queryParamString}
            if (queryParamString) {
                return `${environment.apiUrlMSINCatalogAPI}${url}?${queryParamString}`;
            }            
        }
        return `${environment.apiUrlMSINCatalogAPI}/api/${url}`;
    }*/

    getAuthHeader(): HttpHeaders {
        /// console.log('calling getAuthHeader');

        let headers: HttpHeaders = new HttpHeaders();

        //headers= headers.append('Content-Type', 'application/json');
        //headers=headers.append('Access-Control-Allow-Credentials', 'true');
        //headers=headers.append("Access-Control-Allow-Methods", "POST,PUT,DELETE,GET,OPTIONS");
        let uTokenString = localStorage.getItem('userToken') || '';
        if (uTokenString != '') {
            const userToken = JSON.parse(uTokenString?.toString());
            const authToken = userToken.token; //get the token from State management

            headers = headers.append('Content-Type', 'application/json');
            headers = headers.append('Accept', 'application/json');
            headers = headers.append('Authorization', authToken);

            // headers = headers.append('Access-Control-Allow-Origin', 'https://msincatalogapi-app-2022122811180.ambitioussky-9b439eec.westus.azurecontainerapps.io');
            // headers = headers.append('Access-Control-Allow-Credentials', 'true');
            // headers = headers.append('GET', 'POST');
            //headers = headers.append('Origin','https://msincatalogapi-app-2022122811180.ambitioussky-9b439eec.westus.azurecontainerapps.io')
            ///  console.log('now passing access control token:');
            ///  console.log(headers);
            return headers;
        } else {
            return headers;
        }
    }

    baseGetOptions(): any {
        return {
            headers: this.getAuthHeader(),
            observe: 'response'
        };
    }
}
